import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=392fec56"
var script = {}
import style0 from "./Partners.vue?vue&type=style&index=0&id=392fec56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports